/* eslint-disable */

import DatePickerMixin from '@/mixins/datepicker';
import Dispatchers from '@/mixins/dispatchers';
import DraftData from '@/components/draft-data';
import pdf from 'vue-pdf';
import vuePlayer from '@algoz098/vue-player';
import DownloadDocuments from '@/mixins/downloadDocuments';
import { error, PDFDocument } from 'pdf-lib';

// TIP: https://vuedose.tips/tips/dynamic-imports-in-vue-js-for-better-performance
const ActionsDetail = () => import(/* webpackChunkName: "ActionsDetail" */ '@/components/actions-detail');
const BastanteoGroup = () =>
  import(/* webpackChunkName: "BastanteoGroup" */ '@/views/shared/bastanteo/bastanteo-group');
const BastanteoOthers = () =>
  import(/* webpackChunkName: "BastanteoOthers" */ '@/views/shared/bastanteo/bastanteo-others');
const BastanteoBankAccounts = () =>
  import(/* webpackChunkName: "BastanteoBankAccounts" */ '@/views/shared/bastanteo/bastanteo-bank-accounts');
const BastanteoAssociatesPatrons = () =>
  import(/* webpackChunkName: "BastanteoAssociatesPatrons" */ '@/views/shared/bastanteo/bastanteo-associates-patrons');
const UploadDocument = () => import(/* webpackChunkName: "UploadDocument" */ '@/components/upload-document');

export default {
  name: 'Bastanteo',
  mixins: [Dispatchers, DatePickerMixin, DownloadDocuments],
  components: {
    ActionsDetail,
    BastanteoGroup,
    BastanteoOthers,
    BastanteoBankAccounts,
    BastanteoAssociatesPatrons,
    pdf,
    UploadDocument,
    DraftData,
    vuePlayer
  },

  /**
   * @override
   */
  data() {
    return {
      accountInterveners: null,
      accountOperations: [],
      bankAccount: false,
      BankAccountsDocs: [],
      blockingIssues: 0,
      canDigitalSign: false,
      fileName: null,
      filenamesArray: [],
      filePreview: null,
      filePreviewRight: null,
      filesArray: [],
      fileType: null,
      hasUploadedCC: false,
      hasFinalizedAccount: false,
      horaLimiteEnvioRD: this.$store.getters['configVarsStore/getConfigVar']('LIMIT_HOUR_RD_SEND') || '14',
      intervenerAccounts: [],
      intervenersToSign: [],
      intervenersToSignSelected: [],
      isBlocking: false,
      itemActive: null,
      itemsToDigitalSign: [],
      itemsToValidate: [],
      key_category: null,
      key_subcategory: null,
      manualSign: false,
      numberItemsNotValidated: 0,
      numPages: null,
      operationAccount: {},
      operationDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      othersDocs: [],
      pagesWidth: null,
      playing: true,
      previewItem: null,
      previewType: null,
      previewUuid: null,
      relatedIntervenerUpload: null,
      showUploadSection: false,
      signersWithoutFinveris: [],
      typeSign: null,
      typeUpload: 'account',
      uuidUpload: null,
      isPartialDownload: false,
      selectedItem: null,
      associatesPatronsDocs: [],
      isAllowedToSendAccount: false,
      //variables que controlan carga/estados
      isLoading: false,
      loadingDocument: false,
      sendingDigitalSign: false,
      sendingOpToRD: false,
      sendingIntToRD: false,
      sendingAccToRD: false,
      validatingDocs: false,
      validatingOpStatus: false,
      validatingIntStatus: false,
      validatingAccStatus: false,
      cancellingOpStatus: false,
      allowSendWithoutOperations: false,
      creatingUser: false,
      sendingVideoId: false,
      rejectingVideoId: false,
    };
  },
  props: {
    uuid: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    account: {
      type: Object,
      required: false
    },
    intervener: {
      type: Object,
      required: false
    },
    operation: {
      type: Object,
      required: false
    }
  },

  /**
   * @override
   */
  created() {
    this.fetchData();
  },

  /**
   * @override
   */
  mounted() {
    this.$root.$on('emit_download_doc', this.downloadDocument);
    /**
     * EMIT LANZADO DESDE BASTANTEO-ITEM
     * Le indica al componente padre que muestre la sección de subir archivo
     */
    this.$root.$on('emit_show_upload', this.showUpload);

    /**
     * PREVISUALIZACIÓN DE DOCUMENTO
     * Emit lanzado desde el componente BastanteoItem
     *
     */
    this.$root.$on('emit_preview_file_right', this.previewFileRight);

    /**
     * ITEM ACTIVO
     * Emit lanzado desde el componente BastanteoItem
     */
    this.$root.$on('emit_active_item', this.selectItemActive);

    /**
     * ITEM CHECKEADO
     * Emit lanzado desde el componente BastanteoItem
     */
    this.$root.$on('emit_item_to_validate', this.itemToValidate);

    /**
     * TOTAL de items no validados
     * Emit lanzado desde el componente BastanteoGroup
     */
    this.$root.$on('emit_items_not_validated', this.updateItemsNotValidated);

    /**
     * TOTAL Items de categoría OTHERS
     */
    this.$root.$on('emit_add_others_doc', this.addOthersDoc);

    /**
     * TOTAL Items de categoría DOCUMENTO_ACREDITATIVO_TITULARIDAD_CC
     */
    this.$root.$on('emit_add_bank_account_docs', this.addBankAccountsDocs);

    this.$root.$on('refresh_bastanteo_groups', this.removeBankAccountDocs);
    this.$root.$on('refresh_bastanteo_groups', this.resetValidationCounter);

    this.$root.$on('emit_add_associates_patrons_docs', this.addAssociatesPatronsDocs);
    this.$root.$on('emit_show_reject_video_id', this.showRejectVideoId);

    this.isAllowedToSendWithoutOperations();
    
  },
  /**
   * @override
   */
  beforeDestroy() {
    this.$root.$off('emit_download_doc', this.downloadDocument);
    this.$root.$off('emit_show_upload', this.showUpload);
    this.$root.$off('emit_preview_file_right', this.previewFileRight);
    this.$root.$off('emit_active_item', this.selectItemActive);
    this.$root.$off('emit_item_to_validate', this.itemToValidate);
    this.$root.$off('emit_items_not_validated', this.updateItemsNotValidated);
    this.$root.$off('emit_add_others_doc', this.addOthersDoc);
    this.$root.$off('emit_add_bank_account_docs', this.addBankAccountsDocs);
    this.$root.$off('refresh_bastanteo_groups', this.removeBankAccountDocs);
    this.$root.$off('emit_add_associates_patrons_docs', this.addAssociatesPatronsDocs);
    this.$root.$off('emit_show_reject_video_id', this.showRejectVideoId);
    this.$root.$off('refresh_bastanteo_groups', this.resetValidationCounter);
  },

  methods: {
    /**
     * ITEM ACTIVO
     * Emit lanzado desde el componente BastanteoItem
     *
     * @param {Object} item: información del archivo requerido o que se quiere validar
     * @param {String} type: tipo de objeto (intervener/account/operation)
     * @param {String} uuid: identificador del objeto
     *
     */
    async isAllowedToSendWithoutOperations() {
      if (this.type !== 'account') return;

      this.allowSendWithoutOperations = this.$store.getters['configVarsStore/getAllowSendAccountWithoutOperations'];
      if (this.allowSendWithoutOperations) {
        this.isAllowedToSendAccount = true;
        return;
      }
      
      try {
        const res = await this.$accountsService.getAccountOperations(this.account.uuid);

        const nonPeriodic = res.data.related_operations.filter(op =>
          op.key_operation_type !== 'SOLICITUD_SUSCRIPCION_PERIODICA' &&
          op.key_operation_type !== 'SOLICITUD_REEMBOLSO_PERIODICO' &&
          op.key_operation_type !== 'SOLICITUD_APORTACION_PERIODICA'
        );
        const hasValidatedOperations = nonPeriodic.some(op => ['VALIDATED', 'FINALIZED'].includes(op.operation_status));
        this.isAllowedToSendAccount = hasValidatedOperations;
      } catch (error) {
        console.error(error);
        this.isAllowedToSendAccount = false;
      }
    },
    itemToValidate(item, type, uuid) {
      this.$console.warn('emit_item_to_validate', item, type, uuid);
      const payload = {
        item,
        type,
        uuid
      };

      const is_created = this.itemsToValidate.find(x => {
        return x.item === payload.item && x.type === payload.type && x.uuid === payload.uuid;
      });
      const indexItem = this.itemsToValidate.indexOf(is_created);
      if (indexItem < 0) {
        this.itemsToValidate.push(payload);
      } else {
        this.itemsToValidate.splice(indexItem, 1);
      }

      // Si es firmable y no está firmado, añadir al array de items a firmar
      if (item.uuid && item.is_signable && !item.is_signed) {
        const is_created_sign = this.itemsToDigitalSign.find(x => {
          return x.item === payload.item && x.type === payload.type && x.uuid === payload.uuid;
        });
        const indexItem_sign = this.itemsToDigitalSign.indexOf(is_created_sign);
        if (indexItem_sign < 0) {
          this.itemsToDigitalSign.push(payload);
        } else {
          this.itemsToDigitalSign.splice(indexItem_sign, 1);
        }
      }
    },
    /**
     * ITEM ACTIVO
     * Emit lanzado desde el componente BastanteoItem
     *
     * @param {Object} item: información del archivo requerido o que se quiere validar
     * @param {String} type: tipo de objeto (intervener/account/operation)
     * @param {String} uuid: identificador del objeto
     *
     */
    previewFileRight(item, type, uuid) {
      if (item !== null) {
        if (item.key_subcategory === 'VIDEOIDENTIFICACION' && item.is_validated) {
          this.$toast.warning('Acción no disponible', 'Video identificación ya validada');
          return;
        }
        if (!this.loadingDocument) {
          this.showUploadSection = false;
          this.filePreviewRight = item;
          this.documentPreview(item, type, uuid);
        }
      } else {
        if (!this.loadingDocument) {
          this.showUpload(item, type, uuid);
        }
      }
    },
    /**
     * ACTUALIZA ITEMS NO VALIDADOS
     * Emit lanzado desde el componente BastanteoItem
     *
     * @param {Object} items: items no validados
     *
     */
    updateItemsNotValidated(items) {
      // Reiniciar antes de asignar el nuevo valor
      this.numberItemsNotValidated = 0;
      // Asignar la nueva cantidad
      this.numberItemsNotValidated = items.length;
    },  
    /**
     * AÑADE ITEMS a othersDocs
     * Emit lanzado desde el componente BastanteoItem
     *
     * @param {Object} items: nuevos items con categoría others
     *
     */
    addOthersDoc(items) {
      this.othersDocs = items;
    },
    /**
     * AÑADE ITEMS a BankAccountsDocs
     * Emit lanzado desde el componente BastanteoItem
     *
     * @param {Object} items: nuevos items con categoría others
     *
     */
    addBankAccountsDocs(items) {
      this.BankAccountsDocs = items;
      this.hasUploadedCC = this.BankAccountsDocs.some(doc => doc.data.uuid && doc.data.is_validated);
    },

    addAssociatesPatronsDocs(items) {
      this.associatesPatronsDocs = items;
    },

    removeBankAccountDocs() {
      this.BankAccountsDocs = [];
    },

    resetValidationCounter() {
      this.numberItemsNotValidated = 0;
      this.itemsToValidate = [];
    },    

    classifySigners(interveners) {
      let signersWithFinveris = [];
      let signersWithoutFinveris = [];
      interveners.forEach(intervener => {
        if (intervener.can_sign && intervener.has_finveris_account) {
          signersWithFinveris.push(intervener);
        } else if (intervener.can_sign && !intervener.has_finveris_account) {
          signersWithoutFinveris.push(intervener);
        }
      });
      return [signersWithFinveris, signersWithoutFinveris];
    },

    checkDigitalSignatureIsAllowed(signatureType, signersWithFinveris, signersWithoutFinveris) {
      return signatureType === 'MANCOMUNADA'
        ? !signersWithoutFinveris.length
        : signersWithFinveris.length;
    },

    handleAccountFetch(cfg) {
      this.isLoading = true;
      Promise.all([
        this.$accountsService.getAccountInterveners(this.account.uuid, cfg),
        this.$accountsService.getAccountIssues(this.account.uuid, {}),
        this.$accountsService.getAccountOperations(this.account.uuid, {})
      ])
        .then(res => {
          this.accountInterveners = res[0].data.accounts_intervener;
          const [signersWithFinveris, signersWithoutFinveris] = this.classifySigners(this.accountInterveners);
          this.signersWithoutFinveris = signersWithoutFinveris;
          this.canDigitalSign = this.checkDigitalSignatureIsAllowed(
            this.account.signature_type,
            signersWithFinveris,
            signersWithoutFinveris
          );

          const issues = res[1].data.accounts_issues || [];
          this.blockingIssues = issues.filter(issue => issue.blocking && !issue.is_closed).length;

          this.accountOperations = res[2].data.related_operations;
        })
        .catch(err => {
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
          console.error(err);
        })
        .finally(() => (this.isLoading = false));
    },

    handleIntervenerFetch() {
      this.isLoading = true;
      this.canDigitalSign = this.intervener.personal_data.has_finveris_account;
      Promise.all([
        this.$intervenersService.getIntervenerIssues(this.intervener.uuid, {}),
        this.$intervenersService.getIntervenerParticipantAccounts(this.intervener.uuid, {}),
        this.$intervenersService.getIntervenersByUUIId(this.intervener.uuid, {}),
      ])
        .then(res => {
          const issues = res[0].data.interveners_issues || [];
          this.blockingIssues = issues.filter(issue => issue.blocking && !issue.is_closed).length;
          this.intervenerAccounts = res[1].data.intervener_accounts;
          this.hasFinalizedAccount = this.intervenerAccounts && this.intervenerAccounts.some(intervenerAccount =>
            intervenerAccount.account_data &&
            intervenerAccount.account_data.status === 'FINALIZED'
          )
        })
        .catch(err => {
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
          console.error(err);
        })
        .finally(() => (this.isLoading = false));
    },

    handleOperationFetch(cfg) {
      this.isLoading = true;
      Promise.all([
        this.$accountsService.getAccountsByUUId(this.operation.account_id, {}),
        this.$accountsService.getAccountInterveners(this.operation.account_id, cfg),
        this.$operationsService.getOperationIssues(this.operation.operation_id, {})
      ])
        .then(responses => {
          this.operationAccount = responses[0].data.account;

          this.accountInterveners = responses[1].data.accounts_intervener;
          this.operation.interveners = this.accountInterveners;
          const [signersWithFinveris, signersWithoutFinveris] = this.classifySigners(this.accountInterveners);
          this.signersWithoutFinveris = signersWithoutFinveris;
          this.canDigitalSign = this.checkDigitalSignatureIsAllowed(
            this.operation.signature_type,
            signersWithFinveris,
            signersWithoutFinveris
          );

          const issues = responses[2].data.operations_issues || [];
          this.blockingIssues = issues.filter(issue => issue.blocking && !issue.is_closed).length;
        })
        .catch(err => {
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
          console.error(err);
        })
        .finally(() => (this.isLoading = false));
    },

    /**
     * @override
     */
    fetchData() {
      const cfg = {};
      cfg.params = {};
      cfg.params.$expand = 'account_intervener_role';
      // Reiniciar el contador y la lista de documentos a validar antes de actualizar datos
      this.resetValidationCounter();

      if (this.type === 'account') {
        this.handleAccountFetch(cfg);
      } else if (this.type === 'operation') {
        this.handleOperationFetch(cfg);
      } else if (this.type === 'intervener') {
        this.handleIntervenerFetch();
      }
    },

    async downloadDocument(item) {
      this.isPartialDownload = true;
      this.selectedItem = item;
      await this.downloadDocuments('single');
      this.isPartialDownload = false;
      this.selectedItem = null;
    },

    /**
     * VALIDACIÓN DE DOCUMENTOS en bloque desde el botón
     * Para cada documento almacenado en itemsToValidate lanza un update marcando validate = true
     */
    async validate() {
      // Si no hay documentos a validar, no hacer nada
      if (this.itemsToValidate.length < 1) {
        return;
      }
      this.validatingDocs = true
      const validateEndpoints = [];
      const objectsToValidate = {};
      this.itemsToValidate.forEach(el => {
        if (el.item.uuid) {
          const payload = {
            uuid: el.uuid,
            uuidDocument: el.item.uuid,
            data: { validated: true }
          };
          // Se van guardando los objetos que van a ser validados
          if (!(el.uuid in objectsToValidate)) {
            objectsToValidate[el.uuid] = {};
          }
          objectsToValidate[el.uuid].type = el.type;

          validateEndpoints.push(this.$documentsService.update(el.type, payload));
        } else {
          let objectUuid;
          switch (this.type) {
            case 'operation':
              objectUuid = this.operation.operation_id;
              break;
            case 'account':
              objectUuid = this.account.uuid;
              break;
            case 'intervener':
              objectUuid = this.intervener.uuid;
              break;
          }

          const payload = {
            uuid: objectUuid,
            section: this.type,
            files: [''],
            filesName: [''],
            category: el.item.key_category,
            subcategory: el.item.key_subcategory,
            validated: true
          };

          if (el.item.key_subcategory === 'DOCUMENTO_ACREDITATIVO_TITULARIDAD_CC') {
            payload.uuid_bank_account = el.item.uuid_bank_account;
          }

          validateEndpoints.push(this.$documentsService.upload(payload));
        }
      });

      try {
        const res = await Promise.all(validateEndpoints);
        let updates = 0;
        res.forEach(resultItem => {
          if (resultItem.result.http_code === 200) {
            updates += 1;
          }
        });

        // Se comprueba si hay algun objeto del que se esté validando más de un item a la vez
        // Si lo hay, este tiene que chequerse para ver si puede ser validado
        const itemsToCheck = [];
        for (const key in objectsToValidate) {
          if (objectsToValidate.hasOwnProperty(key)) {
            const element = objectsToValidate[key];
            element.uuid = key;
            itemsToCheck.push(element);
          }
        }
        // Se hace un update vacío a cada objeto que tenga que ser validado
        const patchEndpoints = [];
        itemsToCheck.forEach(el => {
          switch (el.type) {
            case 'intervener':
            case 'interveners':
              patchEndpoints.push(this.$intervenersService.updateIntervenerInfo(el.uuid, {}));
              break;
            case 'account':
              patchEndpoints.push(this.$accountsService.updateAccountInfo(el.uuid, {}));
              break;
            case 'operation':
              patchEndpoints.push(this.$operationsService.updateOperation(el.uuid, {}));
              break;
            default:
              break;
          }
        });
        if (patchEndpoints.length) {
          await Promise.all(patchEndpoints);
        }

        this.itemsToValidate = [];
        if (updates <= 1) {
          this.$toast.success(`Documento validado`, `Se han validado ${updates} documento.`);
        } else {
          this.$toast.success(`Documentos validados`, `Se han validado ${updates} documentos.`);
        }
        this.refresh_view(this.type);
      } catch (err) {
        console.error(err);
      }
      this.validatingDocs = false
    },

    /**
     * MUESTRA UPLOAD
     * Emit lanzado desde el componente BastanteoItem
     *
     * @param {Object} item: información del archivo requerido o que se quiere validar
     * @param {String} type: tipo de objeto (intervener/account/operation)
     * @param {String} uuid: identificador del objeto
     * @param {Boolean} manualSign: manualSign
     * @param {Object} bankAccount: Objecto bank account
     *
     */
    showUpload(item, type, uuid, manualSign, bankAccount = null) {
      this.filesArray = [];
      this.filenamesArray = [];
      this.typeUpload = type;
      this.uuidUpload = uuid;
      this.showUploadSection = true;
      this.manualSign = manualSign === true;
      this.key_category = item.key_category;
      this.key_subcategory = item.key_subcategory;
      this.bankAccount = bankAccount;
      this.relatedIntervenerUpload = item.related_intervener;
    },

    /**
     * Previsualizar documento
     * @param {Object} item: información del archivo requerido o que se quiere validar
     * @param {String} type: tipo de objeto (intervener/account/operation)
     * @param {String} uuid: identificador del objeto
     */
    documentPreview(item, type, uuid) {
      this.loadingDocument = true;
      this.previewItem = item;
      this.previewType = type;
      this.previewUuid = uuid;
      this.$documentsService
          .get(type, uuid, item.uuid)
          .then(res => {
              const newBlob = new Blob([res], { type: 'application/pdf' });
              const urlCreator = window.URL || window.webkitURL;
              this.filePreview = urlCreator.createObjectURL(newBlob);
              this.fileType =
                  res.type !== 'application/octet-stream' ? res.type : 'application/pdf';
              this.fileName = '';
              if (this.fileType === 'application/pdf') {
                  this.pagesWidth = '100%';
                  this.loadingDocument = false;
              }
          })
          .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`))
          .finally(() => {
              this.loadingDocument = false;
          });
  },

    /**
     * Update operation date
     * @return {Promise} response
     */
    updateOperationDate() {
      return this.$operationsService.updateOperation(this.operation.operation_id, {
        operation_date: this.operationDate
      });
    },

    /**
     * Enviar operación a RD
     * @param {Boolean} skipDate No controlar la fecha al enviar
     */
    async sendOperationToRD(skipDate = false) {
      // Si no está validada no debería hacer nada (por seguridad, pero no debería mostrarse el botón)
      if (this.operation.operation_status !== 'VALIDATED') {
        return;
      }

      // Las operaciones periódicas NUNCA se envían a RD, se ponen directamente como PERIODIC_ACTIVE
      const PERIODIC_OPERATION_TYPES = [
        'SOLICITUD_SUSCRIPCION_PERIODICA',
        'SOLICITUD_REEMBOLSO_PERIODICO',
        'SOLICITUD_APORTACION_PERIODICA',
        'SUSCRIPCION_PERIODICA',
        'REEMBOLSO_PERIODICO',
        'APORTACION_PERIODICA'
      ];
      if (PERIODIC_OPERATION_TYPES.includes(this.operation.key_operation_type)) {
        return;
      }

      // Si la fecha es hoy y sobrepasa la hora límite de envío muestra la modal
      if (
        this.operationDate === this.$moment(new Date()).format('YYYY-MM-DD') &&
        this.$moment() > this.$moment(this.horaLimiteEnvioRD, 'h') &&
        !skipDate
      ) {
        this.$bvModal.show('modalSendOperationToRDLate');
      } else {
        // antes de enviar, actualizamos la fecha y si está todo OK se envía
        this.sendingOpToRD = true;
        try {
          await this.updateOperationDate();

          await this.$operationsService.changeOperationStatus(this.operation.operation_id, {
            status: 'RD_SENT',
            sendToRD: true
          });
          this.$toast.success('OK', 'Enviado correctamente');
          this.$root.$emit('refresh_operation');
        } catch (err) {
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
        }
        this.sendingOpToRD = false;
      }
    },

    
    showRejectVideoId() {
      this.$bvModal.show('modalRejectVideoId');
    },

    async confirmRejectVideoId() {
      this.$bvModal.hide('modalRejectVideoId');
      await this.rejectVideoId();
    },

    async rejectVideoId() {
      this.rejectingVideoId = true;
      try {
        await this.$intervenersService.rejectVideoId(this.intervener.uuid);
        this.$toast.success('VideoID rechazado', 'Se ha enviado al interviniente un nuevo enlace para realizar la videoidentificación.');
        this.$root.$emit('refresh_intervener');
        this.$root.$emit('refresh_account');
        this.$root.$emit('refresh_operation');
        this.$root.$emit('refresh_bastanteo_groups');
      } catch (err) {
        this.$toast.error('Error', 'No se ha podido rechazar la videoidentificación.');
      } finally {
        this.rejectingVideoId = false;
      }
    },

    async confirmSendVideoId() {
      this.$bvModal.hide('modalSendVideoId');
      await this.sendVideoId();
    },

    async sendVideoId() {
      this.sendingVideoId = true;
      try {
        await this.$intervenersService.sendVideoId(this.intervener.uuid);
        this.$toast.success('Enlace enviado', 'Se ha enviado el enlace de videoidentificación al interviniente.');
      } catch (err) {
        this.$toast.error('Error', 'No se ha podido enviar el enlace de videoidentificación.');
      } finally {
        this.sendingVideoId = false;
      }
    },

    /**
     * Enviar interviniente a RD
     */
    async sendIntervenerToRD() {
      if (
        this.hasFinalizedAccount &&
        this.intervener.personal_data.intervener_status === 'VALIDADO'
      ) {
        this.sendingIntToRD = true;
        try {
          await this.$intervenersService.changeIntervenerStatus(this.intervener.uuid, {
            status: 'ENVIADO',
            sendToRD: true
          });
          this.$toast.success('OK', 'Enviado correctamente');
          this.$root.$emit('refresh_intervener');
        } catch (err) {
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
        }
        this.sendingIntToRD = false;
      }
    },

    /**
     * Enviar interviniente a RD
     */
    async sendAccountToRD() {
      if (this.account.status === 'VALIDADO') {
        this.sendingAccToRD = true;
        
        if (!this.isAllowedToSendAccount && !this.allowSendWithoutOperations) {
          this.sendingAccToRD = false;
          return
        }

        try {
          if (!this.allowSendWithoutOperations) {
            // Si el allow es false, se mandan también las operaciones validadas
            // Las suscripciones y reembolsos periódicos no se tienen en cuenta
            const operations = await this.$accountsService.getAccountOperations(this.account.uuid);
            const nonPeriodicOperations = operations.data.related_operations.filter(
              operation => operation.key_operation_type !== 'SOLICITUD_SUSCRIPCION_PERIODICA' &&
              operation.key_operation_type !== 'SOLICITUD_REEMBOLSO_PERIODICO' &&
              operation.key_operation_type !== 'SOLICITUD_APORTACION_PERIODICA'
            );

            const validatedOperations = nonPeriodicOperations.filter(
              operation => operation.operation_status === 'VALIDATED'
            );

            if (validatedOperations.length) {
              for (const operation of validatedOperations) {
                this.operation = operation;
                await this.$operationsService.updateOperation(this.operation.operation_code, {
                  operation_date: this.operationDate
                });
                await this.$operationsService.changeOperationStatus(operation.operation_code, {
                  status: 'RD_SENT',
                  sendToRD: true
                });
              }
            }
          }
          await this.$accountsService.changeAccountStatus(this.account.uuid, {
            status: 'ENVIADO',
            sendToRD: true,
            uuid_distributor: this.defaultDistributor
          });
          this.$toast.success('OK', 'Enviado correctamente');
          this.$root.$emit('refresh_account');
        } catch (err) {
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
        }
        this.sendingAccToRD = false;
      }
    },

    /**
     * Cancela envio a RD (cierre de modal)
     */
    cancelSendOperationToRD() {
      this.$bvModal.hide('modalSendOperationToRDLate');
    },

    /**
     * Confirma envio a RD (cierre de modal y sendOperationToRD)
     */
    confirmSendOperationToRD() {
      this.$bvModal.hide('modalSendOperationToRDLate');
      this.sendOperationToRD(true);
    },

    /**
     * Muestra modal de firma digital
     */
    signDigital() {
      const { payloadSignature, intervenersToSign } = this.setIntervenersToSigneItemsSelected(this.itemsToValidate);
      const optionsType = {
        operation: this.operation ? this.operation.signature_type : undefined,
        account: this.account ? this.account.signature_type : undefined
      };
      this.payloadSignature = payloadSignature;
      if (this.type === 'intervener') return this.confirmFirmaDigital();

      this.$bvModal.show('modalFirmaDigital');
      this.intervenersToSign = intervenersToSign;
      this.typeSign = optionsType[this.type] || undefined;
      if (this.typeSign !== 'INDISTINTA') {
        this.intervenersToSignSelected = intervenersToSign;
      }
    },

    // necesito crear tantos paquetes como non_signed_by distintos haya
    setIntervenersToSigneItemsSelected(itemsSelected) {
      const payloadSignature = [];
      const intervenersToSign = [];
      const interveners_id_set = new Set();
      let documentsToSigne;

      if (this.type !== 'intervener') {
        documentsToSigne = itemsSelected.filter(doc => doc.item.non_signed_by !== null).map(doc => doc.item);
        // por cada interviniente mirar los documentos que tiene pendientes de firmar y preparar un paquete para el
        documentsToSigne.forEach(doc =>
          doc.non_signed_by.forEach(intervener => {
            if (!interveners_id_set.has(intervener.uuid)) {
              intervenersToSign.push({
                lastname_1: intervener.lastname_1,
                lastname_2: intervener.lastname_2,
                name: intervener.name,
                uuid: intervener.uuid
              });
            }
            interveners_id_set.add(intervener.uuid);
          })
        );

        for (const intervener_ids of Array.from(interveners_id_set)) {
          const docs = documentsToSigne
            .filter(doc => doc.non_signed_by.some(i => i.uuid === intervener_ids))
            .map(doc => doc.uuid);
          payloadSignature.push({
            document_ids: docs,
            intervener_ids: [intervener_ids]
          });
        }
      } else {
        documentsToSigne = itemsSelected.map(doc => doc.item);
        documentsToSigne.forEach(doc => {
          if (!interveners_id_set.has(this.intervener.uuid)) {
            intervenersToSign.push({
              lastname_1: this.intervener.lastname_1,
              lastname_2: this.intervener.lastname_2,
              name: this.intervener.name,
              uuid: this.intervener.uuid
            });
          }
          interveners_id_set.add(this.intervener.uuid);
        });

        for (const intervener_ids of Array.from(interveners_id_set)) {
          const docs = documentsToSigne.map(doc => doc.uuid);
          payloadSignature.push({
            document_ids: docs,
            intervener_ids: [intervener_ids]
          });
        }
      }

      return { payloadSignature, intervenersToSign };
    },
    /**
     * Cierra modal de firma digital
     */
    cancelModalFirmaDigital() {
      this.$bvModal.hide('modalFirmaDigital');
    },

    /**
     * Setea el usuario para enviar a firma digital
     * @param {Object} item Intervener
     */
    setIntervenerDigitalSgn(item) {
      const uuidIntervener = item.uuid_intervener || item.uuid;
      this.intervenersToSignSelected = [uuidIntervener];
    },

    /**
     * Confirma firma digital
     */
    confirmFirmaDigital() {
      // Si no se han seleccionado firmantes, no hacer nada
      if (!this.intervenersToSignSelected.length && !this.type === 'intervener') {
        return;
      }
      this.documentsSignature();
    },

    async documentsSignature() {
      try {
        this.sendingDigitalSign = true;
        const promises = [];

        if (this.payloadSignature && this.payloadSignature.length) {
          if (this.typeSign === 'INDISTINTA') {
            this.payloadSignature = this.payloadSignature.filter(payload => {
              return this.intervenersToSignSelected.includes(payload.intervener_ids[0]);
            });
          }

          this.payloadSignature.forEach(pack => {
            promises.push(this.$intervenersService.documentSignatures(pack));
          });
        } else {
          const arrayDocs = this.itemsToDigitalSign.map(x => x.item.uuid);
          const payload = {
            document_ids: arrayDocs,
            intervener_ids: [this.intervener.uuid]
          };
          promises.push(this.$intervenersService.documentSignatures(payload));
        }

        await Promise.all(promises);
        this.$toast.success('OK', 'Documentos enviados a firmar satisfactoriamente.');
        this.refresh_view(this.type);
      } catch (error) {
        this.$toast.error(`Error ${error.name}`, `${error.message}`);
      } finally {
        this.$bvModal.hide('modalFirmaDigital');
        this.sendingDigitalSign = false;
      }
    },
     /**
     * Cancel an operation
     */
     cancelOperation() {
      this.$bvModal.show('modalCancelOperation');
    },
    /**
     * Cambia el estado de la operación
     * @param {String} status estado a cambiar
     */
    changeStatusOperation(status) {
      // Si el estado es "VALIDATED" y la operación es periódica, cambiar directamente a "PERIODIC_ACTIVE"
      const PERIODIC_OPERATION_TYPES = [
        'SOLICITUD_SUSCRIPCION_PERIODICA',
        'SOLICITUD_REEMBOLSO_PERIODICO',
        'SOLICITUD_APORTACION_PERIODICA',
        'SUSCRIPCION_PERIODICA',
        'REEMBOLSO_PERIODICO',
        'APORTACION_PERIODICA'
      ];
      const isPeriodic = PERIODIC_OPERATION_TYPES.includes(this.operation.key_operation_type);
      if (isPeriodic && status === "VALIDATED") {
        status = 'PERIODIC_ACTIVE';
      }
      
      this.validatingOpStatus = true;

      if(status === 'CANCELLED') this.cancellingOpStatus = true;
      
      this.$operationsService
        .changeOperationStatus(this.operation.operation_id, { status })
        .then(response => {
          this.$toast.success('OK', 'Estado de la operación cambiado correctamente');
          if (response.data.operationIssueMessage) {
            this.$toast.success('Caso abierto', response.data.operationIssueMessage);
          }
          this.$bvModal.hide('modalCancelOperation');
          this.$root.$emit('refresh_operation');
        })
        .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`))
        .finally(() => {
          this.validatingOpStatus = false
          this.cancellingOpStatus =false
        })
    },

    /**
     * Cancel status change
     */
    cancelCancelOperation() {
      this.$bvModal.hide('modalCancelOperation');
    },

    /**
     * Cambia el estado del interviniente
     * @param {String} status estado a cambiar
     */
    changeStatusIntervener(status) {
      // No hacer nada se intenta validar, hay más de un elemento pendiente de validar y no es una validación forzada
      if (status === 'VALIDADO' && this.numberItemsNotValidated >= 1 && !this.intervener.has_docs_been_downloaded) {
        return;
      }
      this.validatingIntStatus = true;
      this.$intervenersService
        .changeIntervenerStatus(this.intervener.uuid, { status })
        .then(() => {
          this.$toast.success('OK', 'Estado del interviniente cambiado correctamente');
          this.$root.$emit('refresh_intervener');
        })
        .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`))
        .finally(() => this.validatingIntStatus = false)
    },

    /**
     * Cambia el estado de la cuenta
     * @param {String} status estado a cambiar
     */
    async changeStatusAccount(status) {
      // No hacer nada se intenta validar, hay más de un elemento pendiente de validar y no es una validación forzada
      if (status === 'VALIDADO' && (this.numberItemsNotValidated >= 1 && !this.account.has_docs_been_downloaded)) {
        return;
      }
      this.validatingAccStatus = true;
      try {
        let message = 'Estado de la cuenta cambiado correctamente';
        await this.$accountsService.changeAccountStatus(this.account.uuid, { status });


        this.$toast.success('OK', message);
        this.$root.$emit('refresh_account');
      } catch (error) {
        console.error(error);
      }
      this.validatingAccStatus = false;
    },

    // TODO: revisar la creación de incidencias
    /**
     * @override
     */
    createIssue(category) {
      let type;
      let subject;
      let alias;
      switch (this.type) {
        case 'account':
          type = 'ACCOUNT';
          subject = `Incidencia de cuenta ${this.account.id_object}`;
          alias = this.account.id_object;
          break;
        case 'intervener':
          type = 'INTERVENER';
          subject = `Incidencia ${this.intervener.personal_data.name} ${this.intervener.personal_data.lastname_1}`;
          if (category) {
            subject += ` (${category})`;
          }
          alias = `${this.intervener.personal_data.name} ${this.intervener.personal_data.lastname_1}`;
          break;
        case 'operation':
          type = 'OPERATION';
          subject = `Incidencia ${this.operation.id_object}`;
          alias = `Incidencia ${this.operation.id_object}`;
          break;
        default:
          return;
      }
      const _route = {
        name: 'issues_add_view',
        params: [],
        query: {
          type,
          alias,
          subject,
          name: subject,
          view: 'issue-details',
          id: this.uuid || this.object.uuid || this.$route.params.uuid
        }
      };
      const item = {
        route: _route,
        name: subject,
        active: true
      };
      this.$router.push(item.route);
    },

    getIntervenerService(category) {
      switch (category) {
        case 'crs':
          return this.$intervenersService.updateIntervenerCRS;
        case 'fatca':
          return this.$intervenersService.updateIntervenerFATCA;
        default:
          return this.$intervenersService.updateIntervenerInfo;
      }
    },

    /**
     * Muestra un modal de confirmación de cancelación de cuenta
     */
    confirmCancelAccount() {
      this.$bvModal.show('modalCancelAccount');
    },

    /**
     * Elimina los asociados y patronos pertenecientes a una cuenta de tipo jurídica
     * @param {*} accountUuid Uuid de la cuenta a la que están vinculados los asociados y patronos
     * @return {Promise[]} array con las promesas de eliminación de asociados y patronos
     */
    async deleteAssociatesAndPatrons(accountUuid, callback) {
      try {
        let promises = [];
        const associatesRes = await this.$accountsService.getAccountAssociates(accountUuid);
        const associates = associatesRes.data.account_associates;
        const patronsRes = await this.$accountsService.getAccountPatrons(accountUuid);
        const patrons = patronsRes.data.account_patrons;

        for (const associate in associates) {
          promises.push(this.$accountsService.deleteAccountAssociate(accountUuid, associates[associate].uuid));
        }
        for (const patron in patrons) {
          promises.push(this.$accountsService.deleteAccountPatron(accountUuid, patrons[patron].uuid));
        }

        return callback(null, promises);
      } catch (err) {
        return callback(err);
      }
    },

    /**
     * Elimina lógicamente los intervinientes, asociados y patronos de una cuenta,
     * siempre y cuando la cuenta que se pasa por parámetro sea la única a la que pertenecen
     * @param {Object} account Cuenta a la que están asociados los intervinientes
     * @return {Promise[]} array con las promesas de eliminación de los intervinientes
     */
    async softDeleteInterveners(account, callback) {
      try {
        let promises = [];
        // Eliminar asociados y patronos de cuentas jurídicas
        if (account.account_type === 'J') {
          this.deleteAssociatesAndPatrons(account.uuid, (error, prom) => {
            if (error) throw error;
            else promises.push(...prom);
          });
        }

        for (let i = 0; i < account.interveners.length; i++) {
          const intervener = account.interveners[i];
          const response = await this.$intervenersService.getIntervenerParticipantAccounts(intervener.uuid);
          if (response.data.intervener_accounts && response.data.intervener_accounts.length < 2) {
            promises.push(this.$intervenersService.deleteByUUIId(intervener.uuid));
            promises.push(this.$usersService.deleteByUUIId(intervener.uuid));
          }
        }
        return callback(null, promises);
      } catch {
        err;
      }
      {
        return callback(err);
      }
    },

    /**
     * Anulación de cuenta.
     * Incluye intervinientes, asociados, patronos, usuario y cuenta.
     */
    cancelAccount() {
      this.$bvModal.hide('modalCancelAccount');

      this.softDeleteInterveners(this.account, (error, prom) => {
        try {
          let promises = [];

          if (error) throw error;
          else {
            promises.push(...prom);
            promises.push(this.$accountsService.deleteByUUIId(this.account.uuid));
            Promise.all(promises)
              .then(() => {
                this.$toast.success(`Anulada`, `La cuenta ha sido anulada con éxito.`);
              })
              .catch(error => {
                console.error(error);
                this.$toast.error(error.name, error.message);
              });
          }
        } catch (err) {
          console.error(err);
          this.$toast.error(err.name, err.message);
        }
      });
    },

    /**
     * Descarta la información validable cambiada del objeto
     * @param {String} draftField: campo a actualizar
     * @param {String} category: se utiliza para indicar que draft data descartar cuando hay varias posibilidades
     */
    discardDraft(draftField, category) {
      const payload = {};
      payload[draftField] = null;
      switch (this.type) {
        case 'account':
          this.$accountsService
            .updateAccountInfo(this.account.uuid, payload)
            .then(() => {
              this.$toast.success(`Datos descartados`, `Se han descartado los datos pendientes.`);
              this.$root.$emit('refresh_account');
            })
            .catch(err => {
              this.$toast.error(err.name, err.message);
            });
          break;
        case 'intervener':
          const service = this.getIntervenerService(category);
          service(this.intervener.uuid, payload)
            .then(() => {
              this.$toast.success(`Datos descartados`, `Se han descartado los datos pendientes.`);
              this.$root.$emit('refresh_intervener');
            })
            .catch(err => {
              this.$toast.error(err.name, err.message);
            });
          break;
        case 'operation':
          break;
        default:
          return;
      }
    },

    /**
     * Valida la información cambiada del objeto
     * @param {String} draftField: campo a validar
     * @param {String} category: se utiliza para indicar que draft data validar cuando hay varias posibilidades
     */
    async validateDraft(draftField, category) {
      switch (this.type) {
        case 'account':
          const preAccountPayload = this.account[draftField];
          let accountPayload = {};
          let propertiesToUpdate = [];
          accountPayload.draft_data = null;
          for (const property in preAccountPayload) {
              if (
                  property.startsWith('registered_intervener') ||
                  property.startsWith('new_intervener')
              ) {
                  if (!accountPayload.draft_data) {
                      accountPayload.draft_data = {};
                  }
                  accountPayload.draft_data[property] = preAccountPayload[property];
              } else {
                  accountPayload[property] = preAccountPayload[property];
              }
          }

          if (accountPayload.distributor) propertiesToUpdate.push('distributor');
          if (accountPayload.subdistributor) propertiesToUpdate.push('subdistributor');
          try {
            await this.$accountsService.updateAccountInfo(this.account.uuid, accountPayload);
            // Se modifican distribuidor y/o subdistribuidor de las operaciones en vuelo de la cuenta
            if (propertiesToUpdate.length > 0) {
              const promises = [];
              let res = await this.$accountsService.getAccountOperations(this.account.uuid, {});
              let currentOperations = res.data.related_operations.filter(operation =>
                [
                  'REGISTERED',
                  'REGISTERED_ONLINE',
                  'REGISTERED_EMAIL',
                  'REGISTERED_POSTAL',
                  'SIGNED',
                  'VALIDATED'
                ].includes(operation.operation_status)
              );
              for (const operation of currentOperations) {
                let body = {};
                if (propertiesToUpdate.includes('distributor')) body.uuid_distributor = accountPayload.distributor.uuid;
                if (propertiesToUpdate.includes('subdistributor'))
                  body.uuid_subdistributor = accountPayload.subdistributor.uuid;
                promises.push(this.$operationsService.updateOperation(operation.operation_code, body));
              }
              await Promise.all(promises);
            }
            this.$toast.success(`Datos validados`, `Se han validado los datos pendientes.`);
            this.$root.$emit('refresh_account');
          } catch (err) {
            this.$toast.error(err.name, err.message);
          }
          break;
        case 'intervener':
          let intervenerPayload = {};
          if (draftField === 'personal_draft_data') {
            intervenerPayload = this.intervener.personal_data.personal_draft_data;
            intervenerPayload.personal_draft_data = null;
          } else if (draftField === 'contact_draft_data') {
            intervenerPayload = this.intervener.contacts.contact_draft_data;
            intervenerPayload.contact_draft_data = null;
          } else if (draftField === 'fiscal_draft_data') {
            intervenerPayload = this.intervener.fiscal_address.fiscal_draft_data;
            intervenerPayload.fiscal_draft_data = null;
          } else if (draftField === 'draft_data' && category === 'fatca') {
            intervenerPayload = this.intervener.fatca.draft_data;
            intervenerPayload.draft_data = null;
          } else if (draftField === 'draft_data' && category === 'crs') {
            intervenerPayload = this.intervener.crs.draft_data;
            intervenerPayload.draft_data = null;
          }

          const service = this.getIntervenerService(category);
          service(this.intervener.uuid, intervenerPayload)
            .then(() => {
              this.$toast.success(`Datos validados`, `Se han validado los datos pendientes.`);
              this.$root.$emit('refresh_intervener');
            })
            .catch(err => {
              this.$toast.error(err.name, err.message);
            });
          break;
        case 'operation':
          break;
        default:
          return;
      }
    },

    /**
     * ITEM ACTIVO
     * Emit lanzado desde el componente BastanteoItem
     *
     * @param {Object} item: información del archivo a activar
     *
     */
    selectItemActive(item) {
      this.itemActive = item;
    },

    /**
     * Comprobamos si la operación puede ser enviada a RD
     * @param {Object} operation - operation
     * @return {Boolean} Devuelve si se puede mostrar la opción de enviar a RD seleccionados
     */
    operationEnableSendToRD(operation) {
      return (
        operation.operation_status === 'VALIDATED' &&
        // COMENTADA la comprobación de la conciliación: YURI-2386
        // (
        //     (operation.key_operation_type !== 'APORTACION' && operation.key_operation_type !== 'SUSCRIPCION') ||
        //     (operation.reconciliation && operation.reconciliation.status === 'CONCILIADO')
        // ) &&
        (operation.account_status === 'ENVIADO' || operation.account_status === 'FINALIZED')
      );
    },

    register(type) {
      switch (type) {
        case 'INTERVENER':
          this.$intervenersService
            .changeIntervenerStatus(this.intervener.uuid, { status: 'REGISTERED' })
            .then(() => {
              this.$toast.success('Acción realizada correctamente', 'Cambio de estado del interviniente realizado ');
              this.$root.$emit('refresh_intervener');
            })
            .catch(err => {
              this.$toast.error(err.name, err.message);
            });
          break;
        case 'ACCOUNT':
          this.$accountsService
            .changeAccountStatus(this.account.uuid, { status: 'REGISTERED' })
            .then(() => {
              this.$toast.success('Acción realizada correctamente', 'Cambio de estado de cuente realizado ');
              this.$root.$emit('refresh_account');
            })
            .catch(err => {
              this.$toast.error(err.name, err.message);
            });
          break;
        case 'OPERATION':
          this.$operationsService
            .changeOperationStatus(this.operation.operation_id, { status: 'REGISTERED' })
            .then(() => {
              this.$toast.success('Acción realizada correctamente', 'Cambio de estado de operación realizado ');
              this.$root.$emit('refresh_operation');
            })
            .catch(err => {
              this.$toast.error(err.name, err.message);
            });
          break;
        default:
          break;
      }
    },
    checkGenericValidationRequirements(status) {
      const isRegistered = status.includes('REGISTERED');
      const isNotRegisteredPostal = status !== 'REGISTERED_POSTAL';
      const isSigned = status === 'SIGNED';
      return (isRegistered && isNotRegisteredPostal) || isSigned;
    },

    refresh_view(type) {
      switch (type) {
        case 'intervener':
        case 'interveners':
          this.$root.$emit('refresh_intervener');
          this.$root.$emit('refresh_account');
          this.$root.$emit('refresh_operation');
          break;
        case 'account':
          this.$root.$emit('refresh_account');
          this.$root.$emit('refresh_operation');
          break;
        case 'operation':
          this.$root.$emit('refresh_operation');
          break;
        default:
          break;
      }
    },

    updateBlockedStatusOfIntervener() {
      this.isBlocking = true;
      const newStatus = this.intervener.intervener_status === 'BLOQUEADO' ? 'DESBLOQUEADO' : 'BLOQUEADO';
      const intervenerUUid = this.uuid;
      const statusRevert = newStatus === 'BLOQUEADO' ? 'DESBLOQUEADO' : 'BLOQUEADO';

      this.$intervenersService
        .changeIntervenerStatus(intervenerUUid, { status: newStatus })
        .then(() => {
          // bloquear/desbloquear las cuentas en las que el interviniente es titular.
          this.intervenerAccounts.forEach(account => {
            const isHolder = account.account_intervener_role.some(rol => rol == 'TITULAR');
            if (isHolder) {
              this.$accountsService
                .changeAccountStatus(account.uuid_account, { status: newStatus })
                .then(() => {})
                .catch(err => {
                  /*  si falla el des/bloqueo de alguna de las cuentas en las que el interviniente es titlar,
                                se revierte el cambio de estado del interviniente.
                            */
                  this.$intervenersService.changeIntervenerStatus(intervenerUUid, {
                    status: statusRevert
                  });
                  this.$toast.error('err.name', err.message);
                });
            }
          });
        })
        .catch(err => {
          this.$toast.error(err.name, err.message);
        })
        .finally(() => {
          this.refresh_view('intervener');
        });
    },

    isNonEmptyObject(obj) {
      return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length > 0;
    },

    async createUser() {
      this.creatingUser = true;
      try {
        const payload = {
          from_backoffice_bastanteo: true,
          intervener_id: this.intervener.uuid,
          username: this.intervener.personal_data.document_id,
          given_name: this.intervener.personal_data.name,
          family_name_1: this.intervener.personal_data.lastname_1,
          family_name_2: this.intervener.personal_data.lastname_2 || '',
          email: this.intervener.personal_data.email,
          telephone: String(this.intervener.contacts.mobile_phone),
          groupSelected: { uuid: '9c0a2e16-5261-4ba6-89a1-899774c6ac46' },
          uuid_distributor: this.defaultDistributor,
          uuid_subdistributor: null,
          permissionsSelected: null,
          department: null
        };
        const res = await this.$usersService.create(payload);
        this.intervener.uuid_user = res.data.user.uuid;
        this.$toast.success('OK', 'Usuario creado correctamente');
      } catch (err) {
        this.$toast.error('Error', 'No se ha podido crear el usuario');
      } finally {
        this.creatingUser = false;
      }
    }
  },

  computed: {
    displayAccountValidationOption() {
      if (this.account) {
        return this.checkGenericValidationRequirements(this.account.status);
      }
    },
    displayIntervenerValidationOption() {
      if (this.intervener) {
        return this.checkGenericValidationRequirements(this.intervener.intervener_status);
      }
    },
    displayOperationValidationOption() {
      if (this.operation) {
        return this.checkGenericValidationRequirements(this.operation.operation_status);
      }
    },
    /**
     * @return {Object} Objecto del bastanteo
     */
    actualObject() {
      return this.account || this.operation || this.intervener;
    },
    /**
     * @return {Boolea} if has draft data
     */
    hasDraftData() {
      const i = this.intervener;
      if (!i) return false;

      const personal  = i.personal_data && this.isNonEmptyObject(i.personal_data.personal_draft_data);
      const contact   = i.contacts && this.isNonEmptyObject(i.contacts.contact_draft_data);
      const fiscal    = i.fiscal_address && this.isNonEmptyObject(i.fiscal_address.fiscal_draft_data);
      const crs       = i.crs && this.isNonEmptyObject(i.crs.draft_data);
      const fatca     = i.fatca && this.isNonEmptyObject(i.fatca.draft_data);

      return !!(personal || contact || fiscal || crs || fatca);
    },

    isIntervenerValidationCancelAllowed() {
      return (
        !this.isLoading &&
        this.intervener.personal_data.intervener_status === 'VALIDADO' &&
        this.intervenerAccounts.every(account => account.account_data.status !== 'VALIDADO')
      );
    },

    canCreateUser() {
      if (!this.intervener || !this.intervenerAccounts) return false;
      const hasDefaultDistributorAccount = this.intervenerAccounts.some(
        a => a.account_data && a.account_data.uuid_distributor === this.defaultDistributor
      );
      return (
        this.intervener.personal_data.intervener_type === 'F' &&
        hasDefaultDistributorAccount &&
        !this.intervener.uuid_user
      );
    },

    isAccountValidationCancelAllowed() {
      return (
        !this.isLoading &&
        this.account.status === 'VALIDADO' &&
        this.accountOperations.every(operation => operation.operation_status !== 'VALIDATED')
      );
    },

    isAccountCancelAllowed() {
      return this.account && this.account.status != 'FINALIZED' && !this.account.is_deleted;
    },

    isCancelable() {
      const notAllowedStatuses = ['CANCELLED', 'FINALIZED'];
      return !notAllowedStatuses.includes(this.operation.operation_status);
    },

    canDownloadUnifiedPDF() {
      const hasFinverisAccountSignature = this.account?.documentations_signature === 'DIGITAL_FINVERIS';
      const hasFinverisIntervener =
        this.operation && this.operation?.interveners?.some(i => i.has_finveris_account) ||
        this.intervener && this.intervener?.personal_data.has_finveris_account;
      const hasFinveris = hasFinverisAccountSignature || hasFinverisIntervener
      
      // Solo permitir PDF si NO hay Finveris
      return !hasFinveris;
    },

    defaultDistributor() {
      return this.$store.getters['configVarsStore/getDefaultDistributorUuid'];
    },

    hasDigitalFinverisAccount() {
      return (this.intervenerAccounts || []).some(
        a => a.account_data &&
             a.account_data.documentations_signature === 'DIGITAL_FINVERIS' &&
             a.account_data.status !== 'FINALIZED'
      );
    },
  }
};
